export default "/img/parrots/parrot-logo-round.png"